
import { Component, Mixins } from "vue-property-decorator";
import { PrintBehaviorPropertyEditableMixin, FreeInputBehaviorPropertyEditableMixin } from "../../../mixins";
import { default as ClaioMediaDrawableObjectDrawerBase } from "./ClaioMediaDrawableObjectDrawerBase.vue";

@Component
export default class ImageAreaDrawableObjectDrawerBase extends Mixins(ClaioMediaDrawableObjectDrawerBase, PrintBehaviorPropertyEditableMixin, FreeInputBehaviorPropertyEditableMixin) {
}
